import * as actions from "../actionTypes/researchGroupActionTypes";
import researchGroupService from "../../services/ResearchGroups/researchGroupService";
import { assignClassGroupError } from "./classGroupsAction";

//action to set the APIError
export function fetchResearchGroupsRequest() {
  return {
    type: actions.FETCH_RESEARCH_GROUPS_REQUEST,
    payload: {
      data: [],
    },
  };
}

export function fetchResearchGroupsSuccess(data) {
  return {
    type: actions.FETCH_RESEARCH_GROUPS_SUCCESS,
    payload: {
      data,
    },
  };
}

export function fetchResearchGroupsError(data) {
  return {
    type: actions.FETCH_RESEARCH_GROUPS_ERROR,
    payload: {
      data: [],
      message: data.msg,
    },
  };
}

export const fetchResearchGroups = () => {
  return async (dispatch) => {
    try {
      dispatch(fetchResearchGroupsRequest());
      let result = await researchGroupService.fetchResearchGroups();
      return dispatch(fetchResearchGroupsSuccess(result));
    } catch (error) {
      dispatch(fetchResearchGroupsError(error));
      throw error;
    }
  };
};

//action to set the APIError
export function createResearchGroupRequest() {
  return {
    type: actions.CREATE_RESEARCH_GROUP_REQUEST,
    payload: {
      data: [],
    },
  };
}

export function createResearchGroupSuccess(data) {
  return {
    type: actions.CREATE_RESEARCH_GROUP_SUCCESS,
    payload: {
      data: data.msg,
    },
  };
}

export function createResearchGroupError(data) {
  return {
    type: actions.CREATE_RESEARCH_GROUP_ERROR,
    payload: {
      data: [],
      message: data.msg,
    },
  };
}

export const createResearchGroup = (data, callback = null) => {
  return async (dispatch) => {
    try {
      dispatch(createResearchGroupRequest());
      let result = await researchGroupService.createResearchGroup(data);
      return dispatch(createResearchGroupSuccess(result));
    } catch (error) {
      dispatch(createResearchGroupError(error));
      throw error;
    }
  };
};

export function fetchResearchGroupRequest() {
  return {
    type: actions.FETCH_RESEARCH_GROUP_REQUEST,
    payload: {
      data: [],
    },
  };
}

export function fetchResearchGroupSuccess(data) {
  return {
    type: actions.FETCH_RESEARCH_GROUP_SUCCESS,
    payload: {
      data,
    },
  };
}

export function fetchResearchGroupError(data) {
  return {
    type: actions.FETCH_RESEARCH_GROUP_ERROR,
    payload: {
      data: [],
      message: data.message,
    },
  };
}

export const getResearchGroupData = (id) => {
  return async (dispatch) => {
    try {
      dispatch(fetchResearchGroupRequest());
      let result = await researchGroupService.getResearchGroupData(id);
      return dispatch(fetchResearchGroupSuccess(result));
    } catch (error) {
      dispatch(fetchResearchGroupError(error));
      throw error;
    }
  };
};

export function updateResearchGroupRequest(data) {
  return {
    type: actions.UPDATE_RESEARCH_GROUP_REQUEST,
    payload: {
      data,
    },
  };
}

export function updateResearchGroupSuccess(data) {
  return {
    type: actions.UPDATE_RESEARCH_GROUP_SUCCESS,
    payload: {
      data,
    },
  };
}

export function updateResearchGroupError(data) {
  return {
    type: actions.UPDATE_RESEARCH_GROUP_ERROR,
    payload: {
      data: [],
      message: data.msg,
    },
  };
}

export const updateReseaerchGroup = (id, data) => {
  return async (dispatch) => {
    try {
      dispatch(updateResearchGroupRequest());
      let result = await researchGroupService.updateResearchGroup(id, data);
      return dispatch(updateResearchGroupSuccess(result));
    } catch (error) {
      dispatch(updateResearchGroupError(error));
      throw error;
    }
  };
};

//action to set the APIError
export function assignResearchGroupRequest() {
  return {
    type: actions.ASSIGN_RESEARCH_GROUP_REQUEST,
    payload: {
      data: "",
    },
  };
}

export function assignResearchGroupSuccess(data) {
  return {
    type: actions.ASSIGN_RESEARCH_GROUP_SUCCESS,
    payload: {
      data: data.msg,
    },
  };
}

export function assignResearchGroupError(data) {
  return {
    type: actions.ASSIGN_RESEARCH_GROUP_ERROR,
    payload: {
      data: "",
      message: data.msg,
    },
  };
}

export const assignResearchGroup = (id, data) => {
  return async (dispatch) => {
    try {
      dispatch(assignResearchGroupRequest());
      let result = await researchGroupService.assignStudentToResearchGroup(
        id,
        data
      );
      return dispatch(assignResearchGroupSuccess(result));
    } catch (error) {
      dispatch(assignClassGroupError(error));
      throw error;
    }
  };
};

export function rptResearchGroupsRequest() {
  return {
    type: actions.RPT_RESEARCH_GROUPS_REQUEST,
    payload: {
      data: [],
    },
  };
}

export function rptResearchGroupsSuccess(data) {
  return {
    type: actions.RPT_RESEARCH_GROUPS_SUCCESS,
    payload: {
      data,
    },
  };
}

export function rptResearchGroupsError(data) {
  return {
    type: actions.RPT_RESEARCH_GROUPS_ERROR,
    payload: {
      data: [],
      message: data.msg,
    },
  };
}

export const getResearchGroupReportByStudents = (data) => {
  return async (dispatch) => {
    try {
      dispatch(rptResearchGroupsRequest());
      let result = await researchGroupService.getResearchGroupReportByStudents(
        data
      );
      return dispatch(rptResearchGroupsSuccess(result));
    } catch (error) {
      dispatch(rptResearchGroupsError(error));
      throw error;
    }
  };
};
